<script setup lang="ts">
import { Home, LogOut, UserCog } from "lucide-vue-next";
import { RouterLink } from "vue-router";
</script>

<template>
	<div class="p-2 border-2 shadow-md sticky top-0 z-50 bg-background h-16">
		<div class="flex justify-between items-center">
			<RouterLink to="/">
				<img
					class="object-contain h-[36px]"
					src="https://res.cloudinary.com/dxmldil1b/image/upload/q_auto:best,f_auto,h_48/v1692932947/fuelbuddy-favicon.png" />
			</RouterLink>
			<div class="flex gap-x-4 pr-2 transition-all">
				<RouterLink class="active:scale-95" to="/">
					<Home class="h-10 w-10 p-2" />
				</RouterLink>
				<RouterLink class="active:scale-95" to="/profile">
					<UserCog class="h-10 w-10 p-2" />
				</RouterLink>
				<RouterLink class="active:scale-95" to="/logout">
					<LogOut class="h-10 w-10 p-2" />
				</RouterLink>
			</div>
		</div>
	</div>
</template>
